function navegacaoPaginaParaOndeExportar() {
  return window.location.href.includes('/para-onde-exportar');
}


function constroiBreadcrumbParaOndeExportar() {
  if(navegacaoPaginaParaOndeExportar()) {
    construirBreadcrumb(['inicio', 'internacionalizacao']);
  }
}
